import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Useful for showing a loading animation for text content
 * @usage
 * <rx-skeleton-paragraph [numberOfParagraphs]="2"/>
 *
 * @example It will create paragraphs like:
 * -------------
 * ------------
 * ------
 * ------------
 * ------------
 * -----
 * @param numberOfParagraphs - The number of paragraph blocks to display
 * @param testId - The test id for automation tests
 */
@Component({
  standalone: true,
  selector: 'rx-skeleton-paragraph',
  imports: [CommonModule],
  styleUrls: ['./skeleton-paragraph.component.scss'],
  templateUrl: './skeleton-paragraph.component.html',
})
export class SkeletonParagraphComponent {
  @Input() numberOfParagraphs: number = 1;
  @Input() testId: string = 'test-skeleton-paragraph';

  get paragraphs(): number[] {
    return Array.from({ length: this.numberOfParagraphs });
  }

  get lines(): number[] {
    return Array.from({ length: 3 });
  }
}
